import PropTypes from 'prop-types';
import { PetDetailsWithPolicyDetailPropTypes } from './petDetails';

export const BasicTransationPropTypes = {
  Date: PropTypes.string,
  Pet: PropTypes.string,
  Type: PropTypes.string,
  Amount: PropTypes.number,
  Status: PropTypes.string,
  InstallmentLineNumber: PropTypes.number,
  Order: PropTypes.number,
  Policy_InstallmentLineNumber: PropTypes.string
};

export const TransactionPropTypes = PropTypes.shape(BasicTransationPropTypes);

export const EnrichedTransactionsPropTypes = PropTypes.shape({
  ...BasicTransationPropTypes,
  ...PetDetailsWithPolicyDetailPropTypes
});
